"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAppRoot = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    root: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
    },
});
function WebAppRoot(props) {
    const { children } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(Vertical_1.default, { style: { maxWidth: '100%' } }, children)));
}
exports.WebAppRoot = WebAppRoot;
exports.default = WebAppRoot;
